module.exports = __webpack_public_path__ + "media/pdfs/PrepWorks-Roadmap-To-Oxbridge-c5768cbcbc15c27e67ec73e1b3f9cc62.pdf";